// Terminal-styled block for tool-call I/O (args + result).
//
// Named ToolTerminal — NOT Terminal — on purpose: workspace/shared already
// ships a single-line `Terminal` command-bar, and that library is linked in
// the standalone (:1235) build. Defining `Terminal` here would shadow it and
// break every consumer that expects the canonical one (Rule 63: no duplicate
// names across tiers). This component is also fully self-contained so it
// renders in the chrome-connect panel, which only links the brand library.
//
// Consumer passes `label` (header text, or a bundle KEY — resolved through
// polyglot when the host registers it; a host without polyglot shows it as
// given) and `value` (body text) on the element that `extends:
// 'ToolTerminal'`; the children read them off el.parent.
export const ToolTerminal = {
  flow: 'y',
  width: '100%',
  round: 'Y',
  overflow: 'hidden',
  border: 'hairline solid line',

  // The terminal's header: one line, the whole label on hover (the overflow
  // law, §3b rule 8).
  Label: {
    text: (el, s) => {
      const raw = (el.parent && el.parent.label) || 'terminal'
      const fns = el.context && el.context.functions
      if (!fns || typeof fns.polyglot !== 'function') return raw
      try {
        const t = el.call('polyglot', raw)
        return t ? String(t) : raw
      } catch (_) {
        return raw
      }
    },
    title: (el, s) => {
      const raw = (el.parent && el.parent.label) || null
      const fns = el.context && el.context.functions
      if (!raw || !fns || typeof fns.polyglot !== 'function') return raw
      try {
        const t = el.call('polyglot', raw)
        return t ? String(t) : raw
      } catch (_) {
        return raw
      }
    },
    padding: 'Y2 Z',
    // `overlay` is a COLOUR token, never a theme (designSystem/color.js). In
    // the theme slot `getMediaTheme` returned undefined and this label emitted
    // ZERO classes — no plate behind the terminal header. `background:` is the
    // slot that resolves it, to `var(--color-overlay)`.
    background: 'overlay',
    color: 'caption',
    fontSize: 'Z2',
    fontWeight: '700',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },

  Body: {
    tag: 'pre',
    margin: '0',
    padding: 'Z',
    overflow: 'auto',
    maxHeight: 'H',
    theme: 'document',
    color: 'foreground',
    fontFamily: 'monospace',
    fontSize: 'Z2',
    lineHeight: '1.45',
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
    text: (el, s) => {
      let v = el.parent && el.parent.value
      if (typeof v === 'function') {
        try { v = v(el.parent, s) } catch (_) { v = '' }
      }
      return v == null ? '' : String(v)
    }
  }
}
